import { TeamPage } from '@retink/web-ui'
import { api } from '../../lib/api'

// Console binding of the shared TeamPage — a tenant admin governs their own tenant's
// members from the console off `/api/tenant-admin/*`.
export function TenantTeam() {
  return (
    <TeamPage
      api={api}
      apiBase="/api/tenant-admin"
      tenantErrorHelp="This page manages the members of your active tenant. If you have no tenant context, switch into one first."
    />
  )
}
